/** @format */
import dynamic from "next/dynamic";
import { Layout } from "../../components/common/Layout";
const IndiaStore = dynamic(() =>
  import("../../components/UnlayerTemplates/IndiaStore")
);

export default function IndiaStorePage() {
  const meta = {
    title: "Shop curated trends at Qalara wholesale marketplace ",
    description:
      "A curated wholesale e-store for Indian products",
    keywords:
      "Curated, trends, values, categories, wholesale, bulk, ready-to-ship, custom, fashion, accessories, homedecor, furniture, rugs, kitchen, dining, linen, furnishings, artisanal, organic, sustainable, ecofriendly India, Southeast asia, carving, inlay, basketry, weaving, metal, global, exports, imports, vendors, suppliers",
    url: "/explore/India-store/",
  };

  return (
    <Layout meta={meta}>
      <IndiaStore />
    </Layout>
  );
}
